import styled from "styled-components";

export const StyledTable = styled.table<{withoutBorders?: boolean}>`
    width: 100%;
    border-spacing: 0;
    table-layout: fixed;

    thead {
        background: #F6F3F3;
    }

    th {
        text-align: left;
        box-sizing: content-box;
        padding: 9px 16px 10px;
        font-size: 14px;
        font-weight: 400;
    }
    
    th:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
    }

    th:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
    }
    
    td {
        vertical-align: top;
        padding: 12px 16px 9px;
        border-bottom: ${(props) => (props.withoutBorders ? 'none' : '1px solid #E8E8E8')};
    }
`;

